<script lang="ts" setup>
import { useDrawerStore } from "@/stores";
import { Button, Icon, Popover, Slot, Tooltip, useScreenSize } from "@soft-db/ui";
import SideBarSVG from "../SideBarSVG.vue";
import HeaderButtonContent from "./HeaderButtonContent.vue";

defineProps<{
	icon: string;
	name?: string;
	noDrawer?: boolean;
}>();

const { t } = useI18n();

const { mdOrLower } = useScreenSize();
const { toggleDrawer } = useDrawerStore();

const open = ref(false);
function toggleOpen() {
	open.value = !open.value;
}
function close() {
	open.value = false;
}
</script>
<template>
	<div class="flex items-center gap-1">
		<!-- Drawer Toggle -->
		<Tooltip v-if="!mdOrLower && !noDrawer" :tooltip="t('common.toggleDrawer')">
			<Button variant="outline" shape="square" @click="toggleDrawer">
				<Icon>
					<SideBarSVG />
				</Icon>
			</Button>
		</Tooltip>

		<!-- Non clickable header (Space) -->
		<div
			v-if="!$slots.default"
			class="border-border bg-base-100 py-1.25 flex items-center gap-2 text-nowrap rounded-lg border px-3"
		>
			<HeaderButtonContent :icon="icon" :name="name" />
		</div>

		<!-- Mobile pop up -->
		<template v-else-if="mdOrLower">
			<Button :class="open ? 'bg-primary/20' : ''" variant="outline" @click="toggleOpen">
				<HeaderButtonContent :icon="icon" :name="name" clickable />
			</Button>
			<!-- Propagate the close event automatically -->
			<Slot
				class="border-border fixed bottom-0 left-0 right-0 border transition-transform duration-300"
				:class="open ? '' : 'translate-y-80'"
				@close="close"
			>
				<slot />
			</Slot>
		</template>

		<!-- Desktop Popover -->
		<Popover v-else v-model:open="open" align="start">
			<template #trigger>
				<Button :class="open ? 'bg-primary/20' : ''" variant="outline">
					<HeaderButtonContent :icon="icon" :name="name" clickable />
				</Button>
			</template>
			<template #default>
				<!-- Propagate the close event automatically -->
				<Slot @close="close">
					<slot />
				</Slot>
			</template>
		</Popover>
	</div>
</template>
